import { Injectable, Inject } from 'ng-metadata/core';
import {ConfigurationUtil} from '../../../nddUtils/configurationUtil.service';
import {ArrayUtils} from '../../../nddUtils/arrayUtils.service';
import {JournalsService} from "../../../journals/journals.service";
import {DatabasesService} from "../../../journals/databases.service";
import {BriefResultService} from '../../briefResult/briefResult.service';
import {MappingTablesCache} from '../../../mappingTablesCache/mappingTablesCache.service';
import {NewspapersService} from '../../../newspapers/newspapers.service';
import {getLegantoTemplateUrl,getEqualsSearchOperatorHypertextLinkingEnabled, getEqualsSearchOperatorHypertextLinkingTitleFieldEnabled, getEqualsSearchOperatorHypertextLinkingAuthorFieldEnabled, getEqualsSearchOperatorHypertextLinkingSubjectFieldEnabled, getTabToTiles, getSearchConfiguration, getQueryTerms} from '../../../appConfig/appConfigForward';
import { PartiallyTranslatedFieldsUtil } from '../../../nddUtils/partiallyTranslatedFieldsUtil.service';
import {FilterInstitution} from '../../../nddUtils/filterInstitution.service'
import {FilterLanguage} from "../../../nddUtils/filterLanguage.service";
import { IPromise } from 'angular';
import {PrimoResponse} from '../../../infra/dataStructures/PrimoResponses/doc.interfcae';
import {TranslationService} from "../../../translate/translation.service";
import {getInstitutionCode, getUIComponents} from '../../../appConfig/appConfigForward';
import { SmoothScrollUtil } from '../../../nddUtils/smoothScrollUtil.service';
const isArray = require('lodash/isArray');
const  isMatch  = require('lodash/isMatch');
const forEach = require('lodash/forEach');
const cloneDeep= require('lodash/cloneDeep');
const get= require('lodash/get');
const _join= require('lodash/join');
const includes = require('lodash/includes');
import {marcSubFields} from '../../../infra/constants';
import {AuthoritySearchService} from "../../authority/authoritySearch.service";
import {AuthoritySearchBarService} from "../../authority/authoritySearchBar/authoritySearchBar.service";
import {DeiTermService} from "../../deiTerm.service";


export const DO_NOT_HIGHLIGHT_FIELD = 'DoNotHighlightField';
enum EqualsPhraseFields {
	TITLE = 'title',
	SUBJECT = 'sub',
	CREATOR = 'creator',
}

// Subfield used to convey the related term's authority type (derived from MARC 5XX tags),
// used to determine the authority search scope for typed related-term navigation, e.g. $$Stopic
const RELATED_TERM_SEARCH_FIELD_SUBFIELD = '$$S';
const RELATED_TERM_DEFAULT_SEARCH_FIELD = 'keyword';

enum AuthoritySearchOperator {
	Exact = 'exact',
	Contains = 'contains',
	BeginsWith = 'begins_with',
}

@Injectable()
export class ServiceDetailsService {
	private fieldsDetails: any;
    private basicFieldsDetails: any;
	private hlTable: any;
	private fcdTable: any; // Field chains display
	constructor (private configurationUtil: ConfigurationUtil,
				 private arrayUtils:ArrayUtils ,
				 @Inject('$http') private $http: ng.IHttpService,
				 @Inject('$translate') private $translate,
				 private journalsService: JournalsService,
				 private briefResultService: BriefResultService,
				 private mtCache:MappingTablesCache,
                 private databasesService: DatabasesService,
				 private newspapersService: NewspapersService,
				 private authoritySearchService: AuthoritySearchService,
				 private authoritySearchBarService: AuthoritySearchBarService,
				 private filterInstitution: FilterInstitution,
                 private filterLanguage: FilterLanguage,
				 @Inject('$q') private $q: ng.IQService,                
				 private translationService:TranslationService,
				 private partiallyTranslatedFieldsUtil : PartiallyTranslatedFieldsUtil,
				 @Inject('restBaseURLs') private restBaseURLs,
				 private smoothScrollUtil: SmoothScrollUtil,
				 @Inject('$timeout') private $timeout: ng.ITimeoutService,
				 private deiTermService: DeiTermService) {

		this.configurationUtil = configurationUtil;
		this.arrayUtils = arrayUtils;

		let isSuprima = this.configurationUtil.isSuprima();

		this.hlTable = this.mtCache.getTable(this.mtCache.tables.HYPERTEXT_LINKING_DEFINITIONS);
		this.fcdTable = this.mtCache.getTable(this.mtCache.tables.FIELD_CHAINS_DISPLAY);

        let dFields = ['vertitle', 'creator', 'contributor', 'subject', 'lds', 'identifier', 'relation', 'source', 'grantURL'];

		this.fieldsDetails = {
			vertitle : {
				isLinkable : true,
				getKey : ()=> {
					return 'vertitle';
				},
			},
			creator : {
				isLinkable : true,
				getKey : (label) =>{
					return label;
				},
				splitValue: ';'
			},
			contributor : {
				isLinkable : true,
				getKey : ()=> {
					return 'creator';
				},
				splitValue: ';'
			},
			subject : {
				isLinkable : true,
				getKey : (label) =>{
					return 'sub';
				},
				splitValue: ';'
			},
			lds : {
				isLinkable : configurationUtil.getSystemConfiguration('Use local fields 30-39 as lateral links') === 'Y',
				getKey : (label)=> {
					return label.replace('lds', 'lsr');
				}
			},
			grantURL : {
				isLinkable : true,
				getKey : () =>{
					return 'grantURL';
				},
				splitValue: ';'
			},
			/* complex type */
			identifier : {
				complexType : 'id',
				splitValue: ';',
				splitExculdeTypes: ['DOI']
			},
			relation : {
				complexType : 'relatedTitle'
			},


			source : {
				isCollapsible : (values)=> {
					let isCollapsible= false;
					values.forEach((value) =>{
						if (value.match(/ProQuest LLC All rights reserved/i)) {
							isCollapsible=true;
							return;
						}
					});
					return isCollapsible;
				}
			}
		};
        this.basicFieldsDetails = cloneDeep(this.fieldsDetails);

        this.fieldsDetails = this.getFieldDetails(this.fieldsDetails, dFields);
	}

	public scrollToElementId(eID) {
		let elm = document.getElementById(eID);
		if (!elm) {
			return;
		}
		elm.classList.add("section-focused");

		this.$timeout(() => {
			elm.classList.remove("section-focused");
		}, 500);
			this.smoothScrollUtil.scrollTo(eID, '', '');
	}

    get doNotHighlightField(){
       return DO_NOT_HIGHLIGHT_FIELD;
    }
    
	//remove when moving to NDE
	public splitHyperTextLinkingFF() {
		return this.configurationUtil.getFeatureFlag("split_configuration_for_hypertext_linking_uses_exact_and_only");
	}

    public getSubjectTextFromVal(curValue, values){
		curValue = this.cleanDEIMarkers(curValue);
		if (curValue.includes('$$Q')) {
		 	if(this.splitHyperTextLinkingFF() && getEqualsSearchOperatorHypertextLinkingSubjectFieldEnabled()){
				return curValue.split('$$Q')[1];
			} else if(!this.splitHyperTextLinkingFF() && getEqualsSearchOperatorHypertextLinkingEnabled()){
				return curValue.split('$$Q')[1];
			} else{
				if(values.filter(valueItem => (this.cleanDEIMarkers(valueItem).trim() === curValue.split('$$Q')[0].trim())).length > 0){
					return null;
				} else {
					return curValue.split('$$Q')[0];
				}
			}
		}
		return curValue;
	}
    
    public getTextFromVal(value) {
		value = this.cleanDEIMarkers(value);
		if (this.authoritySearchService.isAuthorityState() && this.isSubfieldExist(value, RELATED_TERM_SEARCH_FIELD_SUBFIELD)) {
			let beforeSearchField = value.split(RELATED_TERM_SEARCH_FIELD_SUBFIELD)[0];
			return this.isSubfieldExist(beforeSearchField, '$$Q') ? beforeSearchField.split('$$Q')[0] : beforeSearchField;
		}
		if (value.includes('$$Q')) {
            let text = value.split('$$Q')[0];//text
            if (text.includes('$$C')) {
                text = this.getSubfieldFromVal(text, '$$V');
            }
            return text;
        } else if (value.includes('$$Z')) {
            let text = value.split('$$Z')[0];//text
            if (text.includes('$$C')) {
                text = this.getSubfieldFromVal(text, '$$V');
            }
            return text;
        } else if (value.includes('$$V')) {
            return this.getSubfieldFromVal(value, '$$V');
        } else if (value.includes('$$R')) {
            return value.split('$$R')[0];
        } else if (this.partiallyTranslatedFieldsUtil.isPartiallyTranslated(value)){
			return this.partiallyTranslatedFieldsUtil.removeTranslationTags(value);
		} else {
            return value;
        }
    }

    public getSubfieldFromVal(value, subfield) {
		value = this.cleanDEIMarkers(value);
        if (this.isSubfieldExist(value, subfield)) {
            let val = value.split(subfield)[1];
            if (val.indexOf('$$')!==-1) {
                val = val.substring(0, val.indexOf('$$'))
            }
            return val;
        } else {
            return value;
        }
    }

    // Returns the subfield value, or '' if the subfield does not exist (unlike getSubfieldFromVal, which returns the whole value).
    private getSubfieldValueOrEmpty(value: string, subfield: string): string {
        return this.isSubfieldExist(value, subfield) ? this.getSubfieldFromVal(value, subfield).trim() : '';
    }

    // Derives the authority search scope (search field) for a related term, based on the authority type
    // information (MARC 5XX derived) carried in the $$S subfield, e.g. $$Stopic.
    // Falls back to the default search field when the derived scope isn't part of the configured
    // "Authority Search Scopes" mapping table.
    public getRelatedTermSearchField(value: string): string {
        let extractedSearchField = this.getSubfieldValueOrEmpty(value, RELATED_TERM_SEARCH_FIELD_SUBFIELD);
        let configuredScopes: string[] = this.authoritySearchBarService.SEARCH_FIELD_SCOPES || [];
        return (extractedSearchField && configuredScopes.includes(extractedSearchField))
            ? extractedSearchField
            : RELATED_TERM_DEFAULT_SEARCH_FIELD;
    }

    // Extracts the query to search for when navigating from a related term: prefers the $$Q (hypertext) value,
    // falling back to the plain text preceding any subfield markers.
    public getRelatedTermQuery(value: string): string {
        let extractedAuthorityQuery = this.getSubfieldValueOrEmpty(value, '$$Q');
        return extractedAuthorityQuery || value.split('$$')[0].trim();
    }

    // Selects the first operator available in the customer's "Authority Search Operators"
    // configuration, following the priority order: Exact -> Contains -> Begins With.
    public getPreferredAuthoritySearchOperator(): string {
        let configuredOperators: string[] = (this.authoritySearchBarService.SEARCH_OPERATOR_OPTIONS || []).map((option) => option.code);
        let priorityOrder = [AuthoritySearchOperator.Exact, AuthoritySearchOperator.Contains, AuthoritySearchOperator.BeginsWith];
        let preferredOperator = priorityOrder.find((operator) => configuredOperators.includes(operator));
        if (preferredOperator) {
            return preferredOperator;
        }
        return configuredOperators[0] || AuthoritySearchOperator.Contains;
    }

    public createLegantoLink(item, crsInfo){
        let courseName = (this.getSubfieldFromVal(crsInfo, '$$R')).trim();
        let courseSection = '.' + (this.getSubfieldFromVal(crsInfo, '$$N')).trim();
        courseName = courseName.split('$$M')[0].trim();
        
        let candidateCrsSection;
        if (courseName.lastIndexOf(courseSection) >=0) {
            candidateCrsSection = courseName.substring(courseName.lastIndexOf(courseSection), courseName.length);
        }
         
        if (candidateCrsSection === courseSection) {
            courseName =  courseName.substring(0, courseName.lastIndexOf(courseSection));
        }
        
        let legantoTemplateUrl = getLegantoTemplateUrl();
        if (!legantoTemplateUrl) {
            let links = get(item, 'delivery.link');
            if (!links) {
                return;
            }
 
            let legantoLink = links.filter(link => {
                return link.displayLabel === 'leganto_url' && 
                       link.hyperlinkText && 
                       link.hyperlinkText.trim() === courseName});

            if (legantoLink && legantoLink.length > 0) {
                 return legantoLink[0].linkURL;
            }
        } else {
            let link = legantoTemplateUrl.replace("<course_code>", encodeURIComponent(courseName));
            return link;
        }
    }
   
    public getDisplayedCourseCode(crsInfo) {
        let courseName = (this.getSubfieldFromVal(crsInfo, '$$M')).trim();
        if (!courseName || courseName === crsInfo) {
            return crsInfo.split('$$R')[0].trim();
        }
        return courseName;
    }
    
    public isSubfieldExist(value, subfield) {
        return value.includes(subfield);
    }
    
	private getFieldDetails(basicFields, dFields){
		let fDetails={};

		let chainDisplayObj = {};
		this.fcdTable.forEach((row) => {chainDisplayObj[row.target] = row});

		this.hlTable.forEach((row, index)=>{
			let key = row.target;
			let contextField = row.source3? row.source3 : 'ANY';
			let fDetail ={};

		   if('includes' !== row.target && 'relatedwork' !== row.target){
              fDetail={
				isLinkable:true,
				context: contextField,
				getKey : (label) =>{
					return row.source1;
				},
				splitValue: ';',
				operator: row.source2
			 };
          }else{
            fDetail={
                isLinkable:true,
                context: contextField,
                getKey : (label) =>{
                    return row.source1;
                },
                operator: row.source2
            };
          }
			let complexType = '';

			if (key === 'identifier') {
				complexType =  'id';
			}

			if (key === 'relation') {
				complexType =  'relatedTitle';
			}

			if (complexType !== '') {
				fDetail={
					isLinkable:true,
					context: contextField,
					getKey : (label) =>{
						return row.source1;
					},
					operator: row.source2,
					complexType: complexType
				};
			}
			fDetail['facetField'] = row.source4;
			let chainDisplayRow = get(chainDisplayObj, key);
			if(chainDisplayRow && chainDisplayRow.source1){
				fDetail['chainDelimiter'] = chainDisplayRow.source1;
			}
			fDetails[key] = fDetail;
		});
		//let currIndex = this.hlTable.length;

		dFields.forEach((field)=>{
			if (!fDetails[field]){
				fDetails[field] = basicFields[field];
				//currIndex ++;
			}
		});

		return fDetails;
	}

	private filterEmpty(e) {
		return e.label;
	}

	parseItem(res, item, isAlmaViewer, tab) {
		
		let delimiter = this.configurationUtil.getFullViewConfiguration().delimiter + ' ';

		let labels = item.items.split(','); // get all labels, e.g "items": "creator,contributor"
		let values = [];					// holds all values for current label, it can be multiple
		let label = labels[0];
		let isCollapsible = false;
		if (isAlmaViewer && !item.displayInViewer){
			return {label:null, values:null, isCollapsible:null, showMore:null};
			}

		labels.forEach((curLabel) =>{

			let isToTranslate = false;
			let localFieldsWithUseTranslation = this.configurationUtil.getFieldsWithUseTranslation();
			if (includes(localFieldsWithUseTranslation, curLabel)) {
				isToTranslate = true;
			}

			let val = {
				delimiter: '',
				key:null,
				keyt: curLabel,
				isLinkable:false,
				values: [],
				links: [],
				operator: '',
				facetField: '',
				isFacetExact: false,
				chainDelimiter: null
			};

            let curRes = (curLabel === ('source' || 'language')) ? res.pnx.display[curLabel] : angular.copy(res.pnx.display[curLabel]);
            //no such elements in results
            if (!curRes) {
                return ;
            }
			let config = this.getFieldConfig(curLabel);
			if (config) {
                let recordId = res.pnx.control.recordid[0];
                let context = res.context
                let isPCRecord = false;
                if (context === "PC" || (recordId && recordId.startsWith("TN_"))){
                    isPCRecord = true;
                }
                let key = this.isLdsField(curLabel) ? 'lds' : curLabel

                if(!isPCRecord){
                    if(this.configurationUtil.isSuprima()){
						if(!this.checkMoreThanOneOccurance(curRes, marcSubFields)){
							delete config.splitValue;
						}
                    }else if(this.basicFieldsDetails[key]){
                        config.splitValue = this.basicFieldsDetails[key].splitValue;
                    }
                }
				if (config.getKey) {
					val.key = config.getKey(curLabel); //for linkable field
				}

				val.facetField = config.facetField;

				let isEqualsSearchOperatorHypertextLinkingEnabledField: boolean;
				if(this.splitHyperTextLinkingFF()){
					switch (val.key) {
						case EqualsPhraseFields.TITLE:
							isEqualsSearchOperatorHypertextLinkingEnabledField = getEqualsSearchOperatorHypertextLinkingTitleFieldEnabled();
							break;
						case EqualsPhraseFields.CREATOR:
							isEqualsSearchOperatorHypertextLinkingEnabledField = getEqualsSearchOperatorHypertextLinkingAuthorFieldEnabled();
							break;
						case EqualsPhraseFields.SUBJECT:
							isEqualsSearchOperatorHypertextLinkingEnabledField = getEqualsSearchOperatorHypertextLinkingSubjectFieldEnabled();
							break;
						default:
							break;
					}
				}
				
				if(this.splitHyperTextLinkingFF() && isEqualsSearchOperatorHypertextLinkingEnabledField && (Object.keys(EqualsPhraseFields).find(key => EqualsPhraseFields[key] === val.key)) && tab !== undefined && this.isActiveOperator('equals', tab)){//suprima only
					val.operator = 'equals';
				}
				else if(!this.splitHyperTextLinkingFF() && getEqualsSearchOperatorHypertextLinkingEnabled() && (Object.keys(EqualsPhraseFields).find(key => EqualsPhraseFields[key] === val.key)) && tab !== undefined && this.isActiveOperator('equals', tab)){//suprima only
					val.operator = 'equals';
				}
				else if(config.operator){
					if(config.operator !== 'facet exact' && (tab=== undefined || this.isActiveOperator(config.operator, tab))){
						val.operator = config.operator;
					}else if (tab === undefined){
						val.operator = 'exact';
						val.isFacetExact = true;
					}
				}else if(tab === undefined){
					val.operator = 'exact';
				}
				
				if(val.operator === '') {
					val.operator = 'contains';
				}
				
				let isLinkableForContext = config.context==='ANY' || res.context===config.context;

				val.isLinkable = config.isLinkable && isLinkableForContext;
                if(this.journalsService.isJournalSearch() || this.databasesService.isDBSearch()
						|| this.newspapersService.isNewspapersSearch() || this.newspapersService.isNewspaperItem(res) || this.configurationUtil.getDiscoveryServicesPage()){
					val.isLinkable = false;
				}

				if (this.getFieldConfig(label) && this.getFieldConfig(label).noLabel) {
					label = '';
				}

				if(config.chainDelimiter && !isPCRecord){
					val.chainDelimiter = config.chainDelimiter;
				}
				else if (config.splitValue) {
                    curRes = this.arrayUtils.flattenDeep(
                        curRes.map((value, index, array) => {
							let splitIt = true;
							if (config.splitExculdeTypes) {
								config.splitExculdeTypes.forEach((excludeVal) => {
									if (value.startsWith(excludeVal)) {
										splitIt = false;
									}
								})
							}
							if (splitIt) {
								return value.split(config.splitValue);
							}
							return value;
							
						})
					);
				}
				if (config.complexType) {
                    curRes = curRes.map((value, index, array)=>{
						return value[config.complexType] || value;
					});
				}
				if(config.isCollapsible) {
					isCollapsible = config.isCollapsible(curRes);
				}
			}



			if(curLabel === 'source'){
				curRes= curRes.filter((res)=>res.length > 0);
				curRes = curRes.map((source) => this.briefResultService.remove$$OValues(source));
				curRes = curRes.map((res) => this.parseSourceCodes(res));
				curRes.forEach((res,index) => {
					let defaultTranslation: string = '';
					defaultTranslation = res.replace('fulldisplay.datasource.','');
					curRes[index] = (/\s|\./.test(defaultTranslation)) ? defaultTranslation : this.$translate.instant(res);
				});
				
			}
			else if(curLabel === 'language'){
				curRes = curRes.slice();
				curRes[0].split(';').map((l,index)=>{
					curRes[index] = this.translationService.translateInstantWithDefaultCodeTranslation('lang.' + l.trim(), 'lang.und');
				});
			} else if(curLabel === 'crsinfo') {
                let enableLegantoLink;
                let fullViewConfiguration = this.configurationUtil.getFullViewConfiguration();
                if(fullViewConfiguration) {
                    enableLegantoLink = fullViewConfiguration.enablelegantolink;
                }
                let crsinfo = get(res,'pnx.display.crsinfo[0]');
 				if((enableLegantoLink && crsinfo && this.hasLegantoCoursesToDisplay(curRes) ) && curRes.some((crsinfo) =>this.isLinkForLeganto(crsinfo))|| getLegantoTemplateUrl()) {
				    val.isLinkable = true;
				}
			} else if (curLabel === 'type') {
				if (!isToTranslate) {  
					curRes.forEach((res, i) => {
                        curRes[i] = this.$translate.instant('mediatype.' + res);
					});
				}
			} else if(this.authoritySearchService.isAuthorityState() && curLabel === 'related_terms'){
				val.isLinkable = true;
			}

			if (isArray(curRes)) {
				val.values = curRes;
				if (this.authoritySearchService.isAuthorityState() ) {
					curRes.forEach((res,index) => {
						val.links[index] = this.isLinkForAuthority(res);
					});
				}
			} else {
				val.values = [curRes];
			}


            val.values.forEach((value, index, array) => {
				this.parseValue(value).then((parsedVal : string) => {
					if (isToTranslate) {
						if (this.partiallyTranslatedFieldsUtil.isPartiallyTranslated(parsedVal)) {
							val.values[index] = this.partiallyTranslatedFieldsUtil.parsePartiallyTranslatedFieldInstant(parsedVal);
						} else {
							val.values[index] = this.translationService.translateInstantWithDefault(parsedVal.toLowerCase(), parsedVal, [], '');
						}
					} else if (this.partiallyTranslatedFieldsUtil.isPartiallyTranslated(parsedVal)) {
						val.values[index] = this.partiallyTranslatedFieldsUtil.removeTranslationTags(parsedVal);
					} else {
						if (parsedVal != value){
							val.values[index] = parsedVal;
						}
					}
				});
			});

			val.delimiter = delimiter;
			values.push(val);

		},this);

		if (values.length === 0) {
			return {label:null, values:null, isCollapsible:null, showMore:null};
		}

		return {label:label, values:values, isCollapsible:isCollapsible, showMore:true};

	}

	private isLinkForAuthority(fieldValue) {
		try {
			const url = new URL(fieldValue);
			const validUrlRegex = /^(https?:\/\/)?([^\s:@]+(:[^\s:@]*)?@)?([^\s:@.]+\.)+[^\s:@]{2,}(\/[^\s]*)?$/i;
			return validUrlRegex.test(url.href) ? fieldValue : undefined;
		} catch (e) {
			return undefined;
		}
	}
	
	public isActiveOperator(operator, tab){
		let tabToTile = this.configurationUtil.getTile('SearchTileInterface-Advanced', getTabToTiles(tab));
		let searchConfig = getSearchConfiguration();
		if(searchConfig[tabToTile] !== undefined){
	        let qtvInstance = searchConfig[tabToTile].qtvinstance;
	        let presicionOperators = qtvInstance.map((obj) => {
	        if (obj.qtvid.includes('prescisionOperators')) {
	                return obj.qtvid;
	            }
			 }).filter(this.filterEmptyScop);;
		  	let presicionOperatorVid = presicionOperators[0];
	       	let queryTerms = getQueryTerms();
	       	let uiComponent   = queryTerms[presicionOperatorVid];
	       	let operatorOptions = getUIComponents()[uiComponent].options;
			if(operatorOptions.includes(operator)){
				return true;
			}
		}
		return false;
	}
	
	private filterEmptyScop(scope) {
        if (scope !== '') {
            return scope;
        }
    }

	public isDraftLegnatoList(crsinfo){
		let indexOf$$D = crsinfo.indexOf('$$D');
		if(indexOf$$D !== -1){
			return crsinfo.substring(indexOf$$D).startsWith('$$DDRAFT');
		}
		return false;
	}

	public parseValue(value: string){
		return this.$q((resolve, reject)=>{
            if (!value){
                reject();
                return;
            }
			let valueArr= value.split('$$');
			if (valueArr.length > 1){
                let shifted = valueArr.shift();
				let codesArray= valueArr.filter((s)=>{return s.charAt(0) === 'C'}).map((s)=>{return 'fulldisplay.constants.' + s.slice(1).trim()});
				valueArr= valueArr.map((s)=>{
					switch (s.charAt(0)){
						case 'C': return '$$C'+ this.$translate.instant(codesArray)['fulldisplay.constants.' + s.slice(1).trim()];
						case 'V': return '$$V'+ s.slice(1);
						default: return '$$'+s;
					}
				});
				valueArr.unshift(shifted);
				resolve(valueArr.join(' '));
			}
			else {
				resolve(valueArr.join(' '));
			}
		});
	}

	private parseSourceCodes(value){
		value= value.replace('$$V', '');
		value = 'fulldisplay.datasource.'+value;
		return value;
	}
	
	public parseDetails(res, tab?) {

		//console.log('mtCacheService ' +JSON.stringify( mtCacheService.getTable('mla_subject_headers_relators')));

		//let parseItemWithRes = angular.bind(this, this.parseItem , res);
		
		return this.$q((resolve, reject)=>{ 
			this.$translate.onReady().then(() => {
				resolve(this.configurationUtil.getFullViewConfiguration().resultitemview.map((item)=>this.parseItem(res,item, false, tab)).filter(this.filterEmpty));
			});
		});
	}

	public parseAuthorityDetails(res, tab?) {
		return this.$q((resolve, reject)=>{
			this.$translate.onReady().then(() => {
				resolve(this.configurationUtil.getFullViewConfiguration().authorityitemview.map((item)=>this.parseItem(res,item, false, tab)).filter(this.filterEmpty));
			});
		});
	}
	
	async parseEsploroDetails(res) {

		const params = {institution: getInstitutionCode()};
		const esploroEnrichments = await this.$http.get(this.restBaseURLs.esploroPortalSearchServices + '/getFullDisplayEnrichments?mmsId=' + res.pnx.control.sourcerecordid[0], {params: params});
	    
	    if (esploroEnrichments && esploroEnrichments.data) {
	    	const enrichmentData = esploroEnrichments.data;
	    	
	    	Object.keys(enrichmentData).forEach((sectionKey) => {
	    		const sectionData = enrichmentData[sectionKey];
	    		Object.keys(sectionData).forEach((fieldKey) => {
			    	res.pnx[sectionKey][fieldKey] = sectionData[fieldKey];
		    	}); 
			}); 
	    }
	
		return this.$q((resolve, reject)=> { 
			this.$translate.onReady().then(() => {
				resolve(this.configurationUtil.getFullViewConfiguration().resultitemview.map((item)=>this.parseItem(res,item, false, undefined)).filter(this.filterEmpty));
			});
		});
	} 

	parseValueFromComplexType(complexType, item) {
		return item[complexType];
	}

	private getFieldConfig(label) {
		let config = cloneDeep(this.fieldsDetails)[label];
		if (!config && this.isLdsField(label)) { //check for lds
			config = this.fieldsDetails.lds;
		}
		return config;
	}

    private isLdsField(label){
        let ldsIndex = label.indexOf('lds');
        let ldsNo:Number = label.substring(ldsIndex+3);
        if (ldsIndex ===0 && (ldsNo>29 && ldsNo < 40)) { //check for lds
            return true;
        }
        return false
	}
	
	private checkMoreThanOneOccurance(targetValues: string[], splitValues:string[]) : boolean{
		for(let targetValue of targetValues){
			for(let splitValue of splitValues){
				if(targetValue.split(splitValue).length - 1 > 1){
					return true;
				}
			}
		}
		return false;
	}

	getValuesOfValueItems(value){
		let filterData= this.filterInstitution.filterAndNormalizeData(value, value.values);
		  filterData = this.filterLanguage.filterField(filterData)
		 return filterData;
	 }

	 getPrefix(value) {
		let subfieldValue = this.getSubfieldFromVal(value, '$$C')
		subfieldValue = subfieldValue.replace(/:\s*$/g,':');
		if(subfieldValue.trim() === ''){
			return '';
		}
        return subfieldValue.endsWith(':') ? subfieldValue + ' ' : subfieldValue + ': ';
	}

	public getItemDetailsForAction(item: PrimoResponse.IDoc): IPromise<{}>{
		let deffered = this.$q.defer();
		let rowForTable = {};
		this.parseDetails(item, undefined).then((details)=>{
			details.forEach((detail)=>{
				let normDetail = detail.values.map((values)=>{
					let normValues = this.getValuesOfValueItems(values).map((val)=>{
						if(this.isSubfieldExist(val, '$$C')){
							return this.getPrefix(val) + this.getTextFromVal(val);
						}
						return this.getTextFromVal(val);
					});
					return _join(normValues, values.delimiter || this.configurationUtil.getFullViewConfiguration().delimiter + ' ' || '; ');
				});
				rowForTable[detail.label] = _join(normDetail, this.configurationUtil.getFullViewConfiguration().delimiter + ' ' || '; ');
			});
			deffered.resolve(rowForTable);
		});
		return deffered.promise;
	}

	public getFieldsForExcel(): IPromise<{}>{
		let fields = {};
		let fieldNames = this.configurationUtil.getFullViewConfiguration().resultitemview.map((field)=>{
			let items = field.items;
			if(items){
				return items.split(',')[0];
			}
			return items;
		}).filter(Boolean);
		fieldNames.forEach((field, index)=>{
			fields[field] = {order: index};
		});

		return this.$q((resolve, reject)=>{
			this.$translate(fieldNames.map(name=>'fulldisplay.'+name)).then((results)=>{
				forEach(results, (val, key)=> fields[key.replace('fulldisplay.','')].translation=val);
				resolve(fields);
			});
		});
	}
	public isDisplayedForLeganto(curValue) {
		return !this.isSubfieldExist(curValue, '$$DDRAFT');
    }

	public isLinkForLeganto(curValue) {
        return this.isSubfieldExist(curValue, '$$R');
    }

    public hasLegantoCoursesToDisplay (crsInfoStringArray) {
        return crsInfoStringArray.some((val) => this.isDisplayedForLeganto(val));
    }

    public detailHasValues(detail: any) {
        return detail && detail.values && detail.values[0] && detail.values[0].values;
    }

	public detailHasLegantoCoursesToDisplay(detail){
		return this.detailHasValues(detail) && this.hasLegantoCoursesToDisplay(detail.values[0].values);
	}

	public cleanDEIMarkers(value: string): string {
		return this.deiTermService.cleanDEIMarkers(value);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/details/serviceDetails.service.ts